import http from '@/utils/request.js'

/**
 * 获得项目办理日志
 */
export const auditHistoryPage = (params)=>{
  return http.request({
    url:"/work-station-schedule/auditHistoryPage",
    method:"GET",
    params:params
  })
}
export const getWaitTaskList =(params) =>{
  return http.request({
    url:"/work-station-schedule/getWaitTaskList",
    method:"GET",
    params:params
  })
}

export const getTaskIsAuditing =(query) =>{
  return http.request({
    url: '/project-process/detail/task/is/auditing',
    method: 'get',
    params: query
  })
}